import ResearcherInterestsSection
  from "../../../../framework/component/form/input-types/ResearcherInterestsSection";
import RegistrationModel from "../model/RegistrationModel";
import {useEffect, useState} from "react";
import {
  InterestSection, loadInterestSections,
  SectionKey,
  SECTIONS
} from "../../../../framework/util/ResearcherInterestsUtils";
import {useFieldArray, useFormContext} from "react-hook-form";

// TODO This could be changed to come from backend as well

export default function ResearcherInterests() {
  const [listOfSections, setListOfSections] = useState<InterestSection[]>([]);
  const {control} = useFormContext<RegistrationModel>();
  const {fields, append, remove} = useFieldArray({
    control,
    name: "allinterests"
  })

  useEffect(() => {
    // TODO change to pass researcher ID
    loadInterestSections(-1).then((s) => setListOfSections(s));
    listOfSections.forEach((section) => append([]));
  }, []);

  return <>
    {listOfSections.map((section: InterestSection, index) => (
        <ResearcherInterestsSection<RegistrationModel>
            label={SECTIONS[section.sectionType as SectionKey]}
            helpText={section.sectionDescription.replace(":", "")}
            interestsInSection={section.interests}
            fieldId={`allinterests.${index}`}
            mandatory
            key={`researcher-interests-${index}`}/>
    ))}
  </>
}